import React from 'react';
import { CreditCard, Lock, Shield, CheckCircle } from 'lucide-react';

/**
 * Generic secure payment info panel.
 * Replaces the old PayTR installment table widget.
 */
export default function SecurePaymentInfo({ amount }) {
  return (
    <div className="mt-8 bg-white rounded-lg shadow-sm p-6 w-full border border-gray-100">
      <h3 className="text-xl font-semibold text-gray-900 mb-4 border-b border-gray-100 pb-4">
        Güvenli Ödeme Bilgileri
      </h3>

      <div className="flex items-start gap-3 mb-6 bg-blue-50 text-blue-800 p-4 rounded-md text-sm">
        <Shield className="w-5 h-5 flex-shrink-0 mt-0.5 text-blue-600" />
        <p>
          Ödemeniz 256-bit SSL şifreleme ile korunmaktadır. Kart bilgileriniz güvenli POS altyapısı
          üzerinden işlenir ve sistemimizde saklanmaz.
        </p>
      </div>

      {amount && (
        <div className="mb-6 bg-gray-50 rounded-lg p-4 flex items-center justify-between">
          <span className="text-gray-600 font-medium">Ödenecek Tutar</span>
          <span className="text-2xl font-bold text-gray-900">
            ₺{Number(amount)?.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}
          </span>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="flex flex-col items-center gap-2 p-4 bg-gray-50 rounded-lg border border-gray-100">
          <CreditCard className="w-8 h-8 text-blue-600" />
          <span className="text-sm font-semibold text-gray-800">Kredi Kartı</span>
          <span className="text-xs text-gray-500 text-center">Tüm bankalar desteklenir</span>
        </div>
        <div className="flex flex-col items-center gap-2 p-4 bg-gray-50 rounded-lg border border-gray-100">
          <Lock className="w-8 h-8 text-green-600" />
          <span className="text-sm font-semibold text-gray-800">3D Secure</span>
          <span className="text-xs text-gray-500 text-center">Ekstra güvenlik katmanı</span>
        </div>
        <div className="flex flex-col items-center gap-2 p-4 bg-gray-50 rounded-lg border border-gray-100">
          <CheckCircle className="w-8 h-8 text-teal-600" />
          <span className="text-sm font-semibold text-gray-800">Anlık Onay</span>
          <span className="text-xs text-gray-500 text-center">Ödeme anında doğrulanır</span>
        </div>
      </div>
    </div>
  );
}
